export default __webpack_public_path__ + "static/media/e2.a3a16ec5.png";